import {useCallback} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import useParams from 'components/data/URLParams/useParams'

import {useBrand} from '@vio/core/src/_web/brand/hooks/useBrand'
import {navigateTo} from '@vio/core/src/_web/utils/browser/navigateTo'
import {isFlutterAppWebView} from '@vio/core/src/_web/utils/flutter/isFlutterAppWebView'
import {trackEvent} from '@vio/core/src/analytics/modules/actions'
import {Action, Category, Entity} from '@vio/core/src/analytics/types/Events'

import {getPaymentFlowType} from '../modules/offerCheck/selectors'
import {PaymentFlowType} from '../modules/offerCheck/types'
import {buildAccommodationUrl, buildSearchHotelUrl} from '../utils/urls'

export enum BackButtonMountType {
  default = 'default',
  soldOut = 'soldOut',
  error = 'somethingWentWrong',
  alternativeOfferOverlay = 'alternativeOfferOverlay'
}
export const TRACKING_TIMEOUT_BEFORE_NAVIGATING_BACK = 500

export const useHandleBackButtonClick = () => {
  const urlParams = useParams()
  const dispatch = useDispatch()
  const flowType = useSelector(getPaymentFlowType)
  const {brand} = useBrand()
  const isResumeFlow = flowType === PaymentFlowType.ResumeBooking

  const handleBackButtonClick = useCallback(
    (type: BackButtonMountType = BackButtonMountType.default) => {
      dispatch(
        trackEvent({
          category: Category.User,
          entity: Entity.BackButton,
          action: Action.Clicked,
          payload: {type}
        })
      )

      setTimeout(() => {
        const accommodationUrl = isFlutterAppWebView()
          ? buildSearchHotelUrl(brand, {
              hotelId: urlParams?.hotelId,
              checkIn: urlParams?.checkIn,
              checkOut: urlParams?.checkOut,
              rooms: urlParams?.rooms
            })
          : buildAccommodationUrl(
              brand,
              urlParams?.hotelId,
              urlParams?.checkIn,
              urlParams?.checkOut,
              urlParams?.locale
            )
        if (
          accommodationUrl &&
          (isResumeFlow || type === BackButtonMountType.alternativeOfferOverlay)
        ) {
          navigateTo(accommodationUrl)
          return
        }

        history.back()
        return
      }, TRACKING_TIMEOUT_BEFORE_NAVIGATING_BACK)
    },
    [urlParams, brand, isResumeFlow, dispatch]
  )

  return handleBackButtonClick
}
